const tabs = {
    styleOverrides: {
        width: '100%',

        flexContainer: {
            justifyContent: 'center',
        },

        indicator: {
            backgroundColor: 'transparent',
        },
    },
};

export default tabs;
